import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectValidationResponse } from 'api/integrations';
import { Modal } from 'components/atoms/modal';
import { useTranslation } from 'hooks/use-translation';

const List = styled.ul`
  margin: 8px 0;
`;

type ProjectChangeWarning = {
  erroredTemplates?: ProjectValidationResponse[];
  confirmUpdate: () => void;
  cancelUpdate: () => void;
};
export const ProjectChangeWarning: FC<ProjectChangeWarning> = ({
  erroredTemplates,
  confirmUpdate,
  cancelUpdate,
}) => {
  const warningText = useTranslation(
    'settings.integrations.jira.choose_project.warning.title',
  );
  const continueText = useTranslation('continue');

  return erroredTemplates != null ? (
    <Modal
      visible
      title={warningText}
      onOk={confirmUpdate}
      okButtonProps={{ danger: true }}
      okText={continueText}
      onCancel={cancelUpdate}
    >
      <FormattedMessage
        id="settings.integrations.jira.choose_project.warning.content"
        values={{
          errored_templates: (
            <List>
              {erroredTemplates?.map((erroredTemplate) => (
                <li>
                  {erroredTemplate.resourceName ?? erroredTemplate.resourceId}
                </li>
              ))}
            </List>
          ),
        }}
      />
    </Modal>
  ) : null;
};
